<template>
  <b-form-group id="textarea-y6djq5" :label="properties.label">
    <b-textarea id="textarea-00ve9n" v-model="propertyValue" rows="15" size="sm"></b-textarea>
  </b-form-group>
</template>

<script>
export default {
  name: "TextAreaPropertyType",
  props: ["properties", "property", "value"],
  computed: {
    propertyValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("update-value", this.property, newValue);
      }
    }
  }
};
</script>
